import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const AcceptanceSection = ({
  acceptances,
  onAcceptanceChange,
  typedAgreement,
  onTypedAgreementChange,
  requiredPhrase,
  hasScrolledToBottom
}) => {
  const acceptanceItems = [
    {
      key: 'fundLoss',
      label: 'I acknowledge that BOLTPay is NOT responsible for any loss of funds',
      icon: 'DollarSign',
      color: 'text-error'
    },
    {
      key: 'noSupport',
      label: 'I understand that NO customer support is available',
      icon: 'MessageCircleOff',
      color: 'text-warning'
    },
    {
      key: 'noLiability',
      label: 'I agree that BOLTPay CANNOT be sued for liability',
      icon: 'ShieldOff',
      color: 'text-error'
    },
    {
      key: 'generalTerms',
      label: 'I accept all general terms and conditions',
      icon: 'FileCheck',
      color: 'text-primary'
    }
  ];

  return (
    <div className="p-6 space-y-4 bg-card">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="CheckSquare" size={20} className="text-primary" />
          Required Acknowledgments
        </h3>
        
        {!hasScrolledToBottom && (
          <div className="bg-warning/10 border border-warning rounded-md p-3 mb-4 flex items-start gap-2">
            <Icon name="AlertCircle" size={18} className="text-warning flex-shrink-0 mt-0.5" />
            <p className="text-sm text-warning">
              Please scroll to the bottom of the terms document to enable acceptance
            </p>
          </div>
        )}

        <div className="space-y-3">
          {acceptanceItems?.map((item) => (
            <div
              key={item?.key}
              className={`flex items-start gap-3 p-3 rounded-lg border transition-all ${
                acceptances?.[item?.key]
                  ? 'bg-primary/5 border-primary' :'bg-muted/30 border-border hover:border-muted-foreground'
              } ${!hasScrolledToBottom ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
              onClick={() => hasScrolledToBottom && onAcceptanceChange(item?.key)}
            >
              <Checkbox
                checked={acceptances?.[item?.key]}
                onChange={() => hasScrolledToBottom && onAcceptanceChange(item?.key)}
                disabled={!hasScrolledToBottom}
              />
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <Icon name={item?.icon} size={16} className={item?.color} />
                  <label className="text-sm font-medium text-foreground cursor-pointer">
                    {item?.label}
                  </label>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="pt-4 border-t border-border">
        <h3 className="text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="Edit" size={20} className="text-primary" />
          Verification
        </h3>
        <p className="text-sm text-muted-foreground mb-3">
          Type <strong className="text-foreground">"{requiredPhrase}"</strong> to confirm your acceptance:
        </p>
        <Input
          type="text"
          value={typedAgreement}
          onChange={(e) => onTypedAgreementChange(e?.target?.value)}
          placeholder={`Type "${requiredPhrase}" here`}
          disabled={!hasScrolledToBottom || !Object.values(acceptances)?.every(val => val)}
          className="font-mono"
        />
        {typedAgreement && typedAgreement?.toUpperCase() !== requiredPhrase && (
          <p className="text-xs text-error mt-2 flex items-center gap-1">
            <Icon name="X" size={14} />
            Phrase does not match. Please type exactly: {requiredPhrase}
          </p>
        )}
        {typedAgreement?.toUpperCase() === requiredPhrase && (
          <p className="text-xs text-success mt-2 flex items-center gap-1">
            <Icon name="Check" size={14} />
            Verification complete
          </p>
        )}
      </div>
    </div>
  );
};

export default AcceptanceSection;